import { render, staticRenderFns } from "./ShareHoldingReportList.vue?vue&type=template&id=63314a57&scoped=true&"
import script from "./ShareHoldingReportList.vue?vue&type=script&lang=js&"
export * from "./ShareHoldingReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63314a57",
  null
  
)

export default component.exports